import { render } from "./onDemandPage.vue?vue&type=template&id=ab47c7f6&scoped=true"
import script from "./onDemandPage.vue?vue&type=script&lang=js"
export * from "./onDemandPage.vue?vue&type=script&lang=js"

import "./onDemandPage.vue?vue&type=style&index=0&id=ab47c7f6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab47c7f6"]])

export default __exports__